import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { ACCESS_RIGHTS } from "../constants/accessRights";
import { getCurrentUser, hasAccess } from "../helpers/session_helper";

const Navdata = () => {
  const history = useNavigate();
  const location = useLocation();

  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const shouldFetch = getCurrentUser()
  const { data, refetch } = useGetAccessUsersQuery({}, { skip: !shouldFetch });
  const accessRights = data?.returnData?.map(({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }) => ({
    permissionTypeId,
    allowRead,
    allowWrite,
    allowDelete
  }));

  useEffect(() => {
    refetch();
  }, [location.pathname]);

  useEffect(() => {
    if (accessRights) {
      sessionStorage.setItem("accessRights", JSON.stringify(accessRights));
    }
  }, [accessRights]);

  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);

  const [isDashboard, setIsDashboard] = useState(false);

  const [isFMS, setIsFMS] = useState(false);
  const [isFMSAccounting, setIsFMSAccounting] = useState(false);
  const [isFMSBudget, setIsFMSBudget] = useState(false);
  const [isFMSCollection, setIsFMSCollection] = useState(false);
  const [isFMSDisbursement, setIsFMSDisbursement] = useState(false);

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }

    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }

    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (!iscurrentState.startsWith("FMS")) {
      setIsFMS(false);
    }

    if (!iscurrentState.startsWith("FMSAccounting")) {
      setIsFMSAccounting(false);
    }

    if (!iscurrentState.startsWith("FMSBudget")) {
      setIsFMSBudget(false);
    }

    if (!iscurrentState.startsWith("FMSCollection")) {
      setIsFMSCollection(false);
    }

    if (!iscurrentState.startsWith("FMSDisbursement")) {
      setIsFMSDisbursement(false);
    }
  }, [
    history,

    iscurrentState,

    isApps,
    isAuth,
    isPages,
    isDashboard,

    isFMS,
    isFMSAccounting,
    isFMSBudget,
    isFMSCollection,
    isFMSDisbursement,
  ]);

  const menuItems = [
    {
      label: "MMDA",
      isHeader: true,
      color: "rgb(10, 179, 156)"
    },
    {
      id: "MainDashboard",
      label: "Dashboard",
      icon: "ri-bar-chart-2-fill",
      link: "/",
      click: function (e) {
        setIscurrentState("MainDashboard");
      },
    },

    {
      label: "eGov-FMS",
      isHeader: true,
    },
    {
      id: "fms-accounting",
      label: "Accounting",
      icon: "ri-secure-payment-fill",
      link: "/#",
      parentId: "fms",
      isChildItem: true,
      stateVariables: isFMSAccounting,
      click: function (e) {
        e.preventDefault();
        setIsFMSAccounting(!isFMSAccounting);
        setIscurrentState("FMSAccounting");

      },
      subItems: [
        {
          id: "fms-accounting-transaction-inbox",
          label: "Transactions Inbox",
          link: "/fms/accounting/transactioninboxes",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_STATICDATA_ACCOUNTABLEFORMS,
          ]
        },
        {
          id: "fms-accounting-jev",
          label: "Journal Entry Vouchers",
          link: "/fms/transactions/jev",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_APPROVER,
          ]
        },
        {
          id: "fms-accounting-depreciation-schedules",
          label: "Depreciation Schedules",
          link: "/fms/accounting/depreciationschedules",
          permissionTypeId: [
          ]
        },
        {
          id: "fms-accounting-prepayments",
          label: "Prepayments",
          link: "/fms/transactions/prepayments",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_PREPAYMENTS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_PREPAYMENTS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_PREPAYMENTS_APPROVER,
          ]
        },
        {
          id: "fms-accounting-reports",
          label: "Reports",
          link: "/fms/reports/accounting",
          permissionTypeId: [
          ]
        },
      ],
    },
    {
      id: "fms-budget",
      label: "Budget",
      icon: "ri-money-dollar-circle-line",
      link: "/#",
      parentId: "fms",
      isChildItem: true,
      stateVariables: isFMSBudget,
      click: function (e) {
        e.preventDefault();
        setIsFMSBudget(!isFMSBudget);
        setIscurrentState("FMSBudget");

      },
      subItems: [
        {
          id: "fms-budget-appropriations",
          label: "Appropriations",
          link: "/fms/budget/appropriations",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_APPROPRIATIONS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_APPROPRIATIONS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_APPROPRIATIONS_APPROVER,
          ]
        },
        {
          id: "fms-budget-nca",
          label: "Notice of Cash Allocations",
          link: "/fms/budget/nca",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_APPROVER,
          ]
        },
        {
          id: "fms-budget-allotments",
          label: "Allotments",
          link: "/fms/budget/allotments",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ALLOTMENTS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ALLOTMENTS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ALLOTMENTS_APPROVER,
          ]
        },
        {
          id: "fms-budget-obligations",
          label: "Obligations",
          link: "/fms/transactions/obligations",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_OBLIGATIONS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_OBLIGATIONS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_OBLIGATIONS_APPROVER,
          ]
        },
        {
          id: "fms-budget-lddap",
          label: "LDDAP-ADA",
          link: "/fms/budget/lddap",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_LDDAP_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_LDDAP_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_LDDAP_APPROVER,
          ]
        },
        {
          id: "fms-budget-reports",
          label: "Reports",
          link: "/fms/reports/budget",
          permissionTypeId: [
          ]
        },
      ],
    },
    {
      id: "fms-collection",
      label: "Collection",
      icon: "ri-coin-fill",
      link: "/#",
      parentId: "fms",
      isChildItem: true,
      stateVariables: isFMSCollection,
      click: function (e) {
        e.preventDefault();
        setIsFMSCollection(!isFMSCollection);
        setIscurrentState("FMSCollection");

      },
      subItems: [
        {
          id: "fms-collection-oop",
          label: "Order of Payments",
          link: "/fms/transactions/orderofpayments",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ORDEROFPAYMENTS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ORDEROFPAYMENTS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_ORDEROFPAYMENTS_APPROVER
          ]
        },
        {
          id: "fms-collection-collections",
          label: "Collections",
          link: "/fms/transactions/collections",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_COLLECTIONS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_COLLECTIONS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_COLLECTIONS_APPROVER
          ]
        },
        {
          id: "fms-collection-deposits",
          label: "Deposits",
          link: "/fms/transactions/deposits",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DEPOSITS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DEPOSITS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DEPOSITS_APPROVER
          ]
        },
        {
          id: "fms-collection-reports",
          label: "Reports",
          link: "/fms/reports/collection",
          permissionTypeId: [
          ]
        },
      ],
    },
    {
      id: "fms-disbursement",
      label: "Disbursement",
      icon: "ri-hand-coin-line",
      link: "/#",
      parentId: "fms",
      isChildItem: true,
      stateVariables: isFMSDisbursement,
      click: function (e) {
        e.preventDefault();
        setIsFMSDisbursement(!isFMSDisbursement);
        setIscurrentState("FMSDisbursement");

      },
      subItems: [
        {
          id: "fms-disbursement-vouchers",
          label: "Disbursement Vouchers",
          link: "/fms/transactions/disbursementvouchers",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REVIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_FUNDER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_APPROVER,
          ]
        },
        {
          id: "fms-disbursement-checks",
          label: "Check Disbursements",
          link: "/fms/transactions/checkdisbursements",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CHECKDISBURSEMENTS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CHECKDISBURSEMENTS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CHECKDISBURSEMENTS_APPROVER,
          ]
        },
        {
          id: "fms-disbursement-cash",
          label: "Cash Disbursements",
          link: "/fms/transactions/cashdisbursements",
          permissionTypeId: [
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CASHDISBURSEMENTS_VIEWER,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CASHDISBURSEMENTS_REQUESTOR,
            ACCESS_RIGHTS.FMS_TRANSACTIONS_CASHDISBURSEMENTS_APPROVER,
          ]
        },
        {
          id: "fms-disbursement-reports",
          label: "Reports",
          link: "/fms/reports/disbursement",
          permissionTypeId: [
          ]
        },
      ],
    },
    {
      id: "fms-settings",
      label: "Settings",
      icon: "ri-settings-2-fill",
      link: "/fms/settings",
      parentId: "fms",
      permissionTypeId: [
        ACCESS_RIGHTS.FMS_STATICDATA_ACCOUNTABLEFORMS,
        ACCESS_RIGHTS.FMS_STATICDATA_ACCOUNTCLASSIFICATIONS,
        ACCESS_RIGHTS.FMS_STATICDATA_BANKS,
        ACCESS_RIGHTS.FMS_STATICDATA_BANKBRANCHES,
        ACCESS_RIGHTS.FMS_STATICDATA_BANKACCOUNTS,
        ACCESS_RIGHTS.FMS_STATICDATA_CLIENTS,
        ACCESS_RIGHTS.FMS_STATICDATA_DOCUMENTTYPES,
        ACCESS_RIGHTS.FMS_STATICDATA_FINANCINGSOURCES,
        ACCESS_RIGHTS.FMS_STATICDATA_FUNDCATEGORIES,
        ACCESS_RIGHTS.FMS_STATICDATA_FUNDCLUSTERS,
        ACCESS_RIGHTS.FMS_STATICDATA_GENERALLEDGERS,
        ACCESS_RIGHTS.FMS_STATICDATA_SUBSIDIARYLEDGERS,
        ACCESS_RIGHTS.FMS_STATICDATA_TRANSACTIONTYPES,
      ]
    },
    {
      label: "Security",
      isHeader: true,
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_USERS,
        ACCESS_RIGHTS.CORE_SECURITY_ROLES,
        ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
      ]
    },
    {
      id: "Users",
      label: "Users",
      icon: "ri-admin-fill",
      link: "/security/users",
      click: function (e) {
        setIscurrentState("Users");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_USERS,
      ]
    },
    {
      id: "Roles",
      label: "Roles",
      icon: "ri-lock-unlock-fill",
      link: "/security/roles",
      click: function (e) {
        setIscurrentState("Roles");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_ROLES,
      ],
    },
    {
      id: "AuditLogs",
      label: "Audit Logs",
      icon: "ri-shield-flash-fill",
      link: "/security/auditLogs",
      click: function (e) {
        setIscurrentState("AuditLogs");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS,
      ],
    },
    {
      id: "AccessRequests",
      label: "Access Requests",
      icon: "ri-key-fill",
      link: "/security/accessrequests",
      click: function (e) {
        setIscurrentState("AccessRequests");
      },
      permissionTypeId: [
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR,
        ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER,
      ],
    },
    {
      label: "Application",
      isHeader: true,
    },
    {
      id: "FAQs",
      label: "FAQs",
      icon: "ri-question-fill",
      link: "/socials/faq",
      click: function (e) {
        setIscurrentState("FAQs");
      },
    },
    {
      id: "PrivacyPolicy",
      label: "Privacy Policy",
      icon: "ri-git-repository-private-fill",
      link: "/socials/privacy-policy",
      click: function (e) {
        setIscurrentState("PrivacyPolicy");
      },
    },
    {
      id: "TermsCondition",
      label: "Terms Condition",
      icon: "ri-spam-2-fill",
      link: "/socials/terms-conditions",
      click: function (e) {
        setIscurrentState("TermsCondition");
      },
    },
    {
      id: "Workflow",
      label: "Workflow",
      icon: "ri-organization-chart",
      link: "/workflow",
      click: function (e) {
        setIscurrentState("Workflow");
      },
    },
    {
      id: "Workflow Form",
      label: "Workflow Form",
      icon: "ri-file-list-3-line",
      link: "/workflow-form",
      click: function (e) {
        setIscurrentState("WorkflowForm");
      },
    },
  ];

  const filterMenu = (items) => {
    return items
      .filter(item => hasAccess(item.permissionTypeId, accessRights))
      .map(item => {
        const newItem = { ...item };

        if (item.subItems) {
          newItem.subItems = filterMenu(item.subItems);
          if (newItem.subItems.length === 0) return null;
        }

        if (item.childItems) {
          newItem.childItems = filterMenu(item.childItems);
          if (newItem.childItems.length === 0) return null;
        }

        return newItem;
      })
      .filter(Boolean);
  };

  return <React.Fragment>{filterMenu(menuItems)}</React.Fragment>;
};
export default Navdata;
